var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "show-left": _vm.warehouseInArr.length > 1,
            "left-style": { width: "15%", paddingTop: "10px" },
            "right-style": { width: "85%" }
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-card",
                { attrs: { shadow: "never" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v("进仓编号")])
                  ]),
                  _c(
                    "el-menu",
                    {
                      staticStyle: { border: "none" },
                      attrs: { "default-active": _vm.warehouseInUuid }
                    },
                    _vm._l(_vm.warehouseInArr, function(item) {
                      return _c(
                        "el-menu-item",
                        {
                          key: item.uuid,
                          attrs: { index: item.uuid },
                          on: {
                            click: function() {
                              return (_vm.warehouseInUuid = item.uuid)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(item.warehouseNo))]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLook,
                      expression: "!isLook"
                    }
                  ],
                  staticStyle: { "padding-left": "0px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.editBack }
                        },
                        [_vm._v("取消 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.doSave }
                        },
                        [_vm._v("保存 ")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLook,
                      expression: "isLook"
                    }
                  ],
                  staticStyle: { "padding-left": "0px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.toBackList }
                        },
                        [_vm._v("返回 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showDetail(_vm.warehouseInUuid, 3)
                            }
                          }
                        },
                        [_vm._v("编辑 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.handleDelOrder }
                        },
                        [_vm._v("删除 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onPrint }
                        },
                        [_vm._v("打印 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSplitOrder }
                        },
                        [_vm._v("拆单 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: _vm.handleExportWarehouseInPackageDetail
                          }
                        },
                        [_vm._v("导出入仓箱单 ")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "tabs-container",
                  staticStyle: { "margin-top": "5px" }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "基础信息", name: "basic" } },
                        [
                          _c("base-info", {
                            ref: "baseInfo",
                            attrs: {
                              "warehouse-in-uuid": _vm.warehouseInUuid,
                              "opration-type": _vm.oprationType
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }